export const ADMIN_ACTIONS = [
  {
    label: 'Delete Image',
    value: 'deleteImage',
    description:
      'Delete image metadata, workflow info, search docs, and history',
  },
  {
    label: 'Index to ElasticSearch',
    value: 'indexToElastic',
    description: 'Index latest workflow documents to ElasticSearch',
  },
]
